jQuery(function() {
    initMisc();
    initSlickCarousel();
});

function initMisc() {
    jQuery('.rgc-accordion table').addClass('table');
    let currentUrl = window.location.href;
    let url = new URL(currentUrl);
    let currentCategory = url.searchParams.get('faq_category');
    if (currentCategory !== null) {
        jQuery('.faq-category').removeClass('show');
        let target = jQuery('#' + currentCategory);
        target.addClass('show');
    }
    else {
        jQuery('.all-faq-categories .faq-category:first-child').addClass('show');
    }
    jQuery('#select-faq-category li a').on('click', function(e) {
        e.preventDefault();
        let $holder = jQuery(this);
        if ($holder.data('refresh') === 1) {
            url.searchParams.delete('faq_keyword');
            url.searchParams.set('faq_category', $holder.data('faq-category'));
            let newUrl = url.toString();
            window.location.href = newUrl;
        }
        else {
            jQuery('.faq-category').removeClass('show');
            let category = $holder.data('faq-category');
            let target = jQuery('#' + category);
            target.addClass('show');
        }
    })
}

//slick init
function initSlickCarousel() {
    jQuery('.icon-slider-container').on('init', function(event, slick) {
        jQuery('.slick-track', jQuery(this)).addClass('d-flex');
    });
    jQuery('.icon-slider-container').slick({
        slidesToScroll: 1,
        rows: 0,
        arrows: true,
        dots: false,
        slidesToShow: 1,
        swipe: true,
        infinite: true,
        adaptiveHeight: false,
        mobileFirst: true,
        prevArrow: '<button type="button" class="slick-prev d-block"><i class="fa-solid fa-angle-left"></i><span class="accessibility">Previous Slide</span></button>',
        nextArrow: '<button type="button" class="slick-next d-block"><i class="fa-solid fa-angle-right"></i><span class="accessibility">Next Slide</span></button>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 1400,
                settings: "unslick"
            }
        ]
    });
    jQuery('.history-slider-container').slick({
        slidesToScroll: 1,
        rows: 0,
        arrows: true,
        dots: false,
        slidesToShow: 1,
        swipe: true,
        infinite: true,
        adaptiveHeight: true,
        mobileFirst: true,
        centerMode: false,
        centerPadding: '0px',
        prevArrow: '<button type="button" class="slick-prev d-flex p-5"><i class="fa-solid fa-arrow-left"></i><span class="d-none d-md-inline text-white"> Back</span></button>',
        nextArrow: '<button type="button" class="slick-next d-flex p-5"><span class="d-none d-md-inline text-white">Next </span><i class="fa-solid fa-arrow-right"></i></button>',
    });
    jQuery('.logo-slider-container').on('init', function(event, slick) {
        jQuery('.slick-track', jQuery(this)).addClass('d-flex align-items-center');
    });
    jQuery('.logo-slider-container').slick({
        slidesToScroll: 1,
        rows: 0,
        arrows: true,
        dots: false,
        slidesToShow: 1,
        swipe: true,
        infinite: true,
        adaptiveHeight: false,
        mobileFirst: true,
        prevArrow: '<button type="button" class="slick-prev d-block"><i class="fa-solid fa-angle-left"></i><span class="accessibility">Previous Slide</span></button>',
        nextArrow: '<button type="button" class="slick-next d-block"><i class="fa-solid fa-angle-right"></i><span class="accessibility">Next Slide</span></button>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });
}
